// extracted by mini-css-extract-plugin
module.exports = {"numberChart":"NumberChart_numberChart__D3uDS","nameLabel":"NumberChart_nameLabel__6RP5_","valueLabel":"NumberChart_valueLabel__1Gaj4"};